import { render, staticRenderFns } from "./ozoneAlarmDetail.vue?vue&type=template&id=ec670dae&scoped=true"
import script from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
export * from "./ozoneAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./ozoneAlarmDetail.vue?vue&type=style&index=0&id=ec670dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec670dae",
  null
  
)

export default component.exports